<template>
  <div>
    <tsl-card :cardList="cardList">
      <template v-slot:alarm>
        <div class="alarm-overview">
          <div class="item" v-for="(item, index) in overviewList" :key="index">
            <overview-card :name="item.name" :value="item.value" :path="item.path"></overview-card>
          </div>
        </div>
      </template>
      <template v-slot:topRight>
        <more-arrow path="/dashboard/devops/monitor-room/overview"></more-arrow>
      </template>
    </tsl-card>
  </div>
</template>
<script>
import Card from "@/components/tsl-card/index.vue";
import Ocard from "@/components/overview-card/index.vue";
import More from "@/components/more-arrow/index";
import { reactive, ref } from "vue";
export default {
  name: "alarm-overview",
  components: {
    [Card.name]: Card,
    [Ocard.name]: Ocard,
    [More.name]: More
  },
  props: {
    data: Object
  },
  setup() {
    const overviewList = ref([
      {
        name: "资源告警",
        value: 2,
        path: "/dashboard/devops/monitor-room/resource"
      },
      {
        name: "设备健康度",
        value: 38,
        path: "/dashboard/devops/monitor-room/device"
      },
      {
        name: "感知事件",
        value: 56,
        path: "/dashboard/devops/monitor-room/perception"
      }
    ]);
    const cardList = reactive([
      {
        name: "alarm",
        title: "告警概览",
        topRight: "topRight"
      }
    ]);
    return {
      cardList,
      overviewList
    };
  }
};
</script>
<style scoped lang="less">
.alarm-overview {
  display: flex;
  justify-content: space-between;
  .item {
    width: 100%;
    height: 96px;
    margin-right: 16px;
  }
  .item:nth-child(3n) {
    margin-right: 0;
  }
}
</style>
